<footer class="footer">
    <div class="container">
        <div class="row">
            <div class="col-md-3"></div>
            <div class="col-md-6">
                <span >&#169; {{currentYear}} {{appConfig.institutionName}}.
                    <span *ngIf="appConfig.footerText" [innerHTML]="appConfig.footerText"></span>
                    <span *ngIf="!appConfig.footerText">This card is issued by {{appConfig.institutionName}}, N.A. Subject to credit approval.</span>
                </span>
            </div>
            <div class="col-md-3 d-flex align-items-center footer-right justify-content-center">
            </div>
        </div>
        <div *ngIf="!appConfig.removeFDICStatementLP" class="row">
            <div class="col-md-12 fdic-logo mx-auto text-center">
                <img class="img-fluid" src="/assets/image/fdic-digital-sign.svg" alt="FDIC Digital Sign">
            </div>
        </div>
        <div *ngIf="appConfig.landingPagePhoneNumber && appConfig.phone" class="row">
            <div class="col-md-12 d-flex align-items-center justify-content-center">
                <a href="tel: {{appConfig.phone}}" class="text-decoration-none phone-link">
                    <span class='me-1'>
                        <i class="fas fa-phone"></i>
                        <span class="phone-number"> {{appConfig.phone}} </span>
                    </span></a>
            </div>
        </div>

    </div>
</footer>
